const moduleMap = {
	"./page": () => {
		return Promise.all([__webpack_require__.e(9742), __webpack_require__.e(7656), __webpack_require__.e(5686), __webpack_require__.e(6479), __webpack_require__.e(5515), __webpack_require__.e(5778)]).then(() => (() => ((__webpack_require__(7960)))));
	},
	"./style": () => {
		return __webpack_require__.e(3109).then(() => (() => ((__webpack_require__(3109)))));
	},
	"./translation": () => {
		return Promise.all([__webpack_require__.e(5098), __webpack_require__.e(3050)]).then(() => (() => ((__webpack_require__(1132)))));
	},
	"./reducer": () => {
		return Promise.all([__webpack_require__.e(1136), __webpack_require__.e(967)]).then(() => (() => ((__webpack_require__(967)))));
	},
	"./saga": () => {
		return Promise.all([__webpack_require__.e(4152), __webpack_require__.e(3015)]).then(() => (() => ((__webpack_require__(3015)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});